import React, { FC, useMemo } from 'react';
import { isNonWorkingDay, useViewModel, weekDaysLong } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import { DayIcon } from '../../components';

export const Header: FC = observer(() => {
  const calendarViewModel = useViewModel(CalendarViewModel);

  const weekDayIndex = useMemo(() => {
    const day = calendarViewModel.viewCalendar[0].getDay();
    return day === 0 ? 6 : day - 1;
  }, [calendarViewModel.viewCalendar[0]]);

  const workCalendarDay = calendarViewModel.findWorkCalendarDay(calendarViewModel.viewCalendar[0]);
  const isWeekendHoliday = isNonWorkingDay(weekDayIndex, workCalendarDay);

  return (
    <div className="row weekDays">
      <div className="day time" />
      <div className={calendarViewModel.getClassNameForWeekDay(0, isWeekendHoliday)}>
        {weekDaysLong[weekDayIndex]}
        {' '}
        {calendarViewModel.viewCalendar[0].getDate()}
        {workCalendarDay
        && (
          <DayIcon workCalendarDay={workCalendarDay} />
        )}
      </div>
    </div>
  );
});
